
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    const self = this,
          app = this.$app,
          $ = this.$;
    myApp.server.get('imc/menu_settings/' + self.$route.params.id).then(res => self.settings = res.settings).then(() => myApp.server.get('imc/item/' + self.$route.params.id)).then(poi => self.currency = poi.currency).catch(err => console.log(err));
    const dialog = app.dialog.create({
      el: '.dialog-diners',
      closeByBackdropClick: true
    });
    dialog.open();
    app.range.create({
      el: '.range-slider-hours'
    }).on('change', (range, value) => {
      const v = value < 10 ? '0' + value : value;
      $('.dialog-time-hours').text(v);
      const date = new Date($('#booking_datetime').val());
      date.setHours($('.dialog-time-hours').text() * 1);
      date.setMinutes($('.dialog-time-minutes').text() * 1);

      if (self.checkDateTime(date)) {
        $('.dialog-hour-message').text('');
        $('.dialog-time-hours').removeClass('text-color-red');
        $('.dialog-time-minutes').removeClass('text-color-red');
        $('.dialog-time-sep').removeClass('text-color-red');
      } else {
        $('.dialog-hour-message').text('CHIUSO');
        $('.dialog-time-hours').addClass('text-color-red');
        $('.dialog-time-minutes').addClass('text-color-red');
        $('.dialog-time-sep').addClass('text-color-red');
      }
    });
    app.range.create({
      el: '.range-slider-minutes'
    }).on('change', (range, value) => {
      const v = value < 10 ? '0' + value : value;
      $('.dialog-time-minutes').text(v);
      const date = new Date($('#booking_datetime').val());
      date.setHours($('.dialog-time-hours').text() * 1);
      date.setMinutes($('.dialog-time-minutes').text() * 1);

      if (self.checkDateTime(date)) {
        $('.dialog-hour-message').text('');
        $('.dialog-time-hours').removeClass('text-color-red');
        $('.dialog-time-minutes').removeClass('text-color-red');
        $('.dialog-time-sep').removeClass('text-color-red');
      } else {
        $('.dialog-hour-message').text('CHIUSO');
        $('.dialog-time-hours').addClass('text-color-red');
        $('.dialog-time-minutes').addClass('text-color-red');
        $('.dialog-time-sep').addClass('text-color-red');
      }
    });

    if (this.$route.params.promo) {
      myApp.server.get('imc/promo/' + this.$route.params.promo).then(succ => {
        self.$setState({
          promoCode: succ.promo_code,
          promo: succ,
          dt: succ.datetime_init ? new Date(succ.datetime_init * 1).toString() : null
        });
      }).catch(err => {
        console.log(err);
      });
    }

    $('#booking_datetime').click(() => {
      self.openCalendar();
    });
  },
  destroyed: function () {
    console.log('Booking destroyed');
  },
  on: {
    pageBeforeIn() {
      //this.$('#booking_diners').focus();
      var aOpen = [];

      if (myApp.currentPoi.info && myApp.currentPoi.info.opening) {
        for (let i = 0; i < myApp.currentPoi.info.opening.length; i++) {
          if (myApp.currentPoi.info.opening[i]) {
            let a, b;

            if (myApp.currentPoi.info.opening[i].morning) {
              a = myApp.currentPoi.info.opening[i].morning.split('-');
            }

            if (myApp.currentPoi.info.opening[i].evening) {
              b = myApp.currentPoi.info.opening[i].evening.split('-');
            }

            aOpen.push({
              a: a ? a[0] : false,
              b: a ? a[1] : false,
              c: b ? b[0] : false,
              d: b ? b[1] : false
            });
          } else {
            aOpen.push({
              a: false,
              b: false,
              c: false,
              d: false
            });
          }
        }
      } else {
        for (let i = 0; i < 7; i++) {
          aOpen.push({
            a: false,
            b: false,
            c: false,
            d: false
          });
        }

        this.closed = true;
      }

      this.opened = aOpen;
    }

  },
  data: function () {
    // controlla login
    if (!myApp.user || !myApp.user.id) {
      this.$app.panel.open('.panel-left');
      return;
    } // controlla profilo


    if (!myApp.checkUser()) {
      this.$app.dialog.alert(lng.profileIncomplete, () => {
        this.$router.navigate('/profile/');
      });
      return;
    }

    return {
      lng: lng,
      user: myApp.user || {},
      promoCode: '',
      promo: {},
      date: null,
      diners: 1,
      settings: {}
    };
  },
  methods: {
    dinersChange() {
      this.diners = this.$('#booking_diners').val();
      this.$update();
    },

    closeDialog() {
      this.$app.dialog.close();
    },

    setHourCancel() {
      this.closeDialog();
      this.openCalendar();
    },

    setHour() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const date = new Date($('#booking_datetime').val());
      date.setHours($('.dialog-time-hours').text() * 1);
      date.setMinutes($('.dialog-time-minutes').text() * 1);
      $('#booking_datetime').val(date.toString());
      app.dialog.close();
      $('#booking_notes').focus();

      if (self.checkDateTime(date)) {
        self.date = date;
      } else {
        app.dialog.alert('Esercizio chiuso nel periodo selezionato', () => {
          $('#booking_datetime').val('');
          self.openCalendar();
        });
      }
    },

    checkDateTime(date) {
      const w = date.getDay();
      if (myApp.currentPoi.info && myApp.currentPoi.info.weekdays && myApp.currentPoi.info.weekdays[w]) return false;
      const d = this.opened[w];
      let h = date.getHours() + '';
      let m = date.getMinutes() + '';
      if (h < 10) h = '0' + h;
      if (m < 10) m = '0' + m;
      const hm = h + ':' + m;

      if (d.a <= d.b && d.c <= d.d) {
        return (d.a || d.b) && hm >= d.a && hm <= d.b || (d.b || d.c) && hm >= d.c && hm <= d.d;
      } else if (d.a >= d.b && d.c <= d.d) {
        return (d.a || d.b) && hm >= d.a || hm <= d.b || (d.b || d.c) && hm >= d.c && hm <= d.d;
      } else if (d.a >= d.b && d.c >= d.d) {
        return (d.a || d.b) && hm >= d.a || hm >= d.b || (d.b || d.c) && hm >= d.c || hm <= d.d;
      } else if (d.a <= d.b && d.c >= d.d) {
        return (d.a || d.b) && hm >= d.a && hm <= d.b || (d.b || d.c) && hm >= d.c || hm <= d.d;
      }
    },

    setDiners() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const n = $('.dialog-diners-diners').text() * 1;
      $('#booking_diners').val(n);
      self.diners = n;
      self.$update();
      app.dialog.close('.dialog-diners');
      self.openCalendar();
    },

    dinersMinus() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const n = $('.dialog-diners-diners').text() * 1;

      if (n <= 1) {
        return;
      }

      $('.dialog-diners-diners').text(n - 1);
    },

    dinersPlus() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const n = $('.dialog-diners-diners').text() * 1;
      $('.dialog-diners-diners').text(n + 1);
    },

    openCalendar() {
      const self = this,
            app = this.$app,
            $ = this.$;
      app.calendar.create({
        value: [$('#booking_datetime').val() ? new Date($('#booking_datetime').val()) : new Date()],
        minDate: new Date().setHours(-12),
        closeOnSelect: true,
        openIn: 'customModal',
        header: true,
        backdrop: true,
        headerPlaceholder: 'Select date',
        sheetPush: true
      }).on('close', calendar => {
        calendar.value[0].setHours(12);
        $('#booking_datetime').val(calendar.value[0].toISOString().substring(0, 10));
        app.dialog.create({
          el: '.dialog-time',
          closeByBackdropClick: true,
          on: {
            open() {
              const date = new Date($('#booking_datetime').val());
              date.setHours($('.dialog-time-hours').text() * 1);
              date.setMinutes($('.dialog-time-minutes').text() * 1);

              if (self.checkDateTime(date)) {
                $('.dialog-hour-message').text('');
                $('.dialog-time-hours').removeClass('text-color-red');
                $('.dialog-time-minutes').removeClass('text-color-red');
                $('.dialog-time-sep').removeClass('text-color-red');
              } else {
                $('.dialog-hour-message').text('CHIUSO');
                $('.dialog-time-hours').addClass('text-color-red');
                $('.dialog-time-minutes').addClass('text-color-red');
                $('.dialog-time-sep').addClass('text-color-red');
              }
            }

          }
        }).open();
      }).open();
    },

    sendForm() {
      const self = this,
            $ = this.$,
            app = this.$app;
      const diners = $('#booking_diners').val();

      if (!diners || diners == '0') {
        $('#booking_diners').focus();
        $('#booking_diners').parents('.item-input').addClass('has-error');
        return;
      } else {
        $('#booking_diners').parents('.item-input').removeClass('has-error');
      }

      if (!self.date) {
        self.openCalendar();
        $('#booking_datetime').parents('.item-input').addClass('has-error');
        return;
      } else {
        $('#booking_datetime').parents('.item-input').removeClass('has-error');
      }

      myApp.bookingData = {
        poi: self.$route.params.id,
        client_code: $('#booking_client_code').val(),
        datetime: self.date,
        diners: $('#booking_diners').val(),
        notes: $('#booking_notes').val(),
        promo: self.promo,
        settings: self.settings
      };

      if (myApp.checkUser()) {
        self.$router.navigate('/booking_confirm/');
      } else {
        app.dialog.alert(lng.profileIncomplete, () => {
          this.$router.navigate('/profile/');
        });
      }
    }

  },
  id: '2f47c0f6c7',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">Booking</div>\n      </div>\n    </div>\n    <div class="page-content bg-color-white">\n      <div class="list no-hairlines">\n        <ul>\n          <li class="item-content item-input">\n            <div class="item-media">\n              <img width="32" src="static/Cliente.png" alt=""/>\n            </div>\n            <div class="item-inner">\n              <div class="item-title">';
      r += c(ctx_1.lng.clientCode, ctx_1);
      r += ': ';
      r += c(ctx_1.user.client_code, ctx_1);
      r += '</div>\n              <input id="booking_client_code" type="hidden" disabled placeholder="';
      r += c(ctx_1.lng.clientCode, ctx_1);
      r += '" value="';
      r += c(ctx_1.user.client_code, ctx_1);
      r += '">\n              <!-- <span class="input-clear-button"></span> -->\n            </div>\n          </li>\n          <li class="item-content item-input padding-top">\n            <div class="item-media">\n              <img width="32" src="static/Coperti.png" alt=""/>\n            </div>\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <input id="booking_diners" @change="dinersChange" type="tel" placeholder="';
      r += c(ctx_1.lng.diners, ctx_1);
      r += '">\n                <span class="input-clear-button"></span>\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input padding-top">\n            <div class="item-media">\n              <img width="32" src="static/DataOra.png" alt=""/>\n            </div>\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <input id="booking_datetime" type="text" \n                       ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.dt, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' value="';
          r += c(ctx_2.dt, ctx_2);
          r += '" ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                       readonly="readonly" placeholder="';
      r += c(ctx_1.lng.dateAndTime, ctx_1);
      r += '">\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input padding-top">\n            <div class="item-media"> \n              <img class="md-only" style="position: absolute; top: 25px" width="32" src="static/Note.png" alt=""/>\n              <img class="ios-only" width="32" src="static/Note.png" alt=""/>\n            </div>\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <textarea id="booking_notes" placeholder="';
      r += c(ctx_1.lng.notes, ctx_1);
      r += '"></textarea>\n                <span class="input-clear-button"></span>\n              </div>\n            </div>\n          </li>\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.promoCode, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <li class="item-content item-input padding-top">\n            <div class="item-media">\n              <i class="f7-icons icon-rounded bg-color-imc text-color-primary">star_fill</i>\n            </div>\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <input id="booking_promo_code" type="text" disabled placeholder="';
          r += c(ctx_2.lng.promoCode, ctx_2);
          r += '" value="';
          r += c(ctx_2.promoCode, ctx_2);
          r += '">\n                <span class="input-clear-button"></span>\n              </div>\n            </div>\n          </li>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </ul>\n      </div>\n      <div class="block">\n        ';
      r += c(ctx_1.lng.bookingPrice, ctx_1);
      r += ': ';
      r += c(ctx_1.currency, ctx_1);
      r += ' ';
      r += Template7Helpers.js.call(ctx_1, "(this.settings.booking_price *1).toFixed(2)", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.settings.booking_price_type == 'for_person'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += c(ctx_2.lng.forPerson, ctx_2);
          r += '. <br/>\n        ';
          r += c(ctx_2.lng.bookingTotalPrice, ctx_2);
          r += ': ';
          r += c(ctx_2.currency, ctx_2);
          r += ' ';
          r += Template7Helpers.js.call(ctx_2, "((this.settings.booking_price * 1) * (this.diners * 1)).toFixed(2)", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n\n      <div class="padding" style="margin-top: 40px">\n        <a href="#" @click="sendForm"\n           class="button button-large button-fill button-round bg-imc text-color-white">\n          ';
      r += c(ctx_1.lng.book, ctx_1);
      r += '\n          <img width="22" src="static/check.png" alt=""/></a>\n      </div>\n\n    </div>\n\n    <div class="dialog dialog-diners">\n      <h1>';
      r += c(ctx_1.lng.diners, ctx_1);
      r += '</h1>\n\n      <a href="#" class="diners-minus" @click="dinersMinus"><i class="icon f7-icons">minus</i></a>\n      <span class="dialog-diners-diners">2</span>\n      <a href="#" @click="dinersPlus"><i class="icon f7-icons">plus</i></a>\n\n      <div class="row margin-bottom-half">\n        <div class="col">\n          <!-- <a @click="closeDialog" class="button button-large button-round button-outline icon-only">\n            <i class="icon f7-icons">arrow_left</i>\n          </a> -->\n        </div>\n        <div class="col">\n          <a class="button button-large button-round button-fill bg-color-imc text-color-yellow icon-only" \n             @click="setDiners"\n             href="#">\n            <i class="icon f7-icons">arrow_right</i>\n          </a>\n        </div>\n      </div>\n    </div>\n\n    <div class="dialog dialog-time">\n\n      <h1>';
      r += c(ctx_1.lng.hour, ctx_1);
      r += '</h1>\n\n      <span class="dialog-time-hours">12</span>\n      <span class="dialog-time-sep">:</span>\n      <span class="dialog-time-minutes">00</span>\n      <div  class="dialog-hour-message text-color-red text-uppercase bold" style="height: 1em"></div>\n\n      <div class="block">\n        <div class="text-align-left">Ore</div>\n        <div class="range-slider range-slider-hours"\n             data-min="0"\n             data-max="23"\n             data-step="1"\n             data-value="12"\n             data-scale="true"\n             data-scale-steps="1"\n             ></div>\n        <div style="height: 2em"></div>\n        <div class="text-align-left">Minuti</div>\n        <div class="range-slider range-slider-minutes"\n             data-min="0"\n             data-max="45"\n             data-step="15"\n             data-value="0"\n             data-scale="true"\n             data-scale-steps="1"\n             ></div>\n      </div>\n      <div class="row margin-half">\n        <div class="col">\n          <a class="button button-large button-round button-outline text-color-yellow icon-only" \n             @click="setHourCancel"\n             href="#">\n            <i class="icon f7-icons">arrow_left</i> \n          </a>\n        </div>\n        <div class="col">\n          <a class="button button-large button-round button-fill bg-color-imc text-color-yellow icon-only" \n             @click="setHour"\n             href="#">\n            <i class="icon f7-icons">arrow_right</i>\n          </a>\n        </div>\n      </div>\n\n    </div>\n\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    